<template>
  <div>
    <Search v-model="value" shape="round" placeholder="搜索课群考试ID" />
    <!-- <Swipe class="my-swipe" :show-indicators="false" autoplay="5000">
      <SwipeItem
        >1: 导入数据文件，包含列[账号密码、分数时间、课群、考试ID]</SwipeItem
      >
      <SwipeItem>2: 点击下方全部登录按钮检查信息的有效性</SwipeItem>
      <SwipeItem>3: 若错误列中有信息则更正重新提交或者删除</SwipeItem>
      <SwipeItem>4: 付款全部提交考试即可</SwipeItem>
    </Swipe> -->
    <Button
      icon="question-o"
      type="warning"
      style="width: 30%; border-radius: 0"
      >帮助</Button
    >
    <Uploader
      :after-read="afterRead"
      accept="text/plain"
      result-type="text"
      max-count="1"
      style="margin-bottom: 0; width: 70%"
    >
      <Button icon="plus" type="success" style="width: 100%; border-radius: 0"
        >上传文件</Button
      >
    </Uploader>
    <!-- 顶部 -->
    <Tabs v-model:active="active">
      <Tab>
        <template #title>
          <div style="margin: 10px 25px">
            <Badge :content="25" :offset="[5, 0]" color="#1989fa">
              <div>全部</div>
            </Badge>
          </div>
        </template>
      </Tab>
      <Tab>
        <template #title>
          <div style="margin: 10px 25px">
            <Badge :content="15" :offset="[5, 0]">
              <div>错误</div>
            </Badge>
          </div>
        </template>
      </Tab>
      <Tab>
        <template #title>
          <div style="margin: 10px 25px">
            <Badge :content="15" :offset="[5, 0]">
              <div>已开始</div>
            </Badge>
          </div>
        </template>
      </Tab>
    </Tabs>

    <transition :name="transitionName">
      <Collapse v-model="activeNames" class="Collapse_" v-show="CollapseIsShow">
        <SwipeCell v-for="(item, index) in showData" :key="index">
          <CollapseItem
            :name="index.toString()"
            ref="CollapseItemRefs"
            :class="isFailure(item.isSuccess)"
          >
            <template #title>
              <div style="height: 100%; display: flex">
                <transition name="van-fade">
                  <Checkbox v-show="allSelect" v-model="selectS[index]" />
                </transition>
                <div class="list-content">
                  <span class="list-content-phone">{{ item.phone }}</span>
                  <span class="list-content-status"
                    >账户密码错误{{ item.isSuccess }}</span
                  >
                </div>
              </div>
            </template>
            <template #value>
              <div style="color: rgb(255 0 0 / 66%); font-weight: bold">
                ¥ <span style="font-size: 24px">6.90</span>
              </div>
            </template>
            <!-- 被折叠的内容 -->
            <template #default>
              <CellGroup inset>
                <Card
                  style="background-color: white"
                  title="“国强我强，我强国强”答题活动"
                  desc="“国强我强，我强国强”"
                  thumb="/imge2.jpeg"
                  price="6.90"
                >
                  <template #tags>
                    <span style="color: red">正在考试中</span></template
                  >
                  <template #num>
                    <Button
                      icon="edit"
                      color="linear-gradient(to right, rgb(77 79 81 / 82%) 0%, rgb(129 139 140 / 89%) 100%)"
                      size="small"
                      >修改考试&nbsp;</Button
                    >
                  </template>
                </Card>
                <CellGroup>
                  <Field
                    v-model="item.phone"
                    label="手机号"
                    placeholder="请输入手机号"
                  />
                  <Field
                    v-model="item.password"
                    label="密码"
                    placeholder="请输入密码"
                  />
                </CellGroup>
                <sliderParameterVue
                  v-model:examTime="data.examTime"
                  v-model:examScore="data.examScore"
                />
                <Field>
                  <template #input>
                    <Button
                      size="small"
                      color="linear-gradient(to right, rgb(36 139 199) 0%, rgb(128, 208, 199) 100%)"
                      round
                      block
                    >
                      👆🏻提交检查👆🏻
                    </Button>
                  </template>
                </Field>
              </CellGroup>
            </template>
          </CollapseItem>
          <template #right>
            <Button type="danger" text="删除" style="height: 100%" />
          </template>
        </SwipeCell>
      </Collapse>
    </transition>

    <SubmitBar :price="3050">
      <Checkbox v-model="allSelect">全选</Checkbox>
      <template #button>
        <ActionBarButton
          type="warning"
          :text="allSelect ? '选中检查' : '全部检查'"
          style="border-radius: 999px 0px 0px 999px"
          @click="allSelect ? checkSelect() : checkAll()"
        />
        <ActionBarButton
          type="danger"
          :text="allSelect ? '删除' : '下单'"
          :disabled="!allSelect"
          style="border-radius: 0px 999px 999px 0"
        />
      </template>
    </SubmitBar>
  </div>
</template>
<script setup>
import { ref, onMounted, watch } from "vue";
// import textswitch from "@/components/switch.vue";
import sliderParameterVue from "@/components/sliderParameter.vue";
import {
  Button,
  Uploader,
  // Dialog,
  Collapse,
  CollapseItem,
  // Icon,
  // Tag,
  // Switch,
  Card,
  SwipeCell,
  Field,
  CellGroup,
  Tab,
  Tabs,
  Badge,
  // Swipe,
  // SwipeItem,
  SubmitBar,
  Checkbox,
  Search,
  ActionBarButton,
} from "vant";
const activeNames = ref([]);
const active = ref(0);
const selectS = ref([false, false, false]);
const CollapseItemRefs = ref([]);
const CollapseIsShow = ref(true);
const transitionName = ref("van-slide-left");
const showData = ref([]);
const initialData = ref([
  {
    phone: "18992456789",
    password: "123456",
    targetScore: 80,
    targetTime: 120,
    groupId: "123",
    examId: "444",
    isSuccess: 0,
  },
  {
    phone: "13692456789",
    password: "123456",
    targetScore: 80,
    targetTime: 120,
    groupId: "123",
    examId: "444",
    isSuccess: 0,
  },
  {
    phone: "13782456789",
    password: "123456",
    targetScore: 80,
    targetTime: 120,
    groupId: "123",
    examId: "444",
    isSuccess: 0,
  },
]);
onMounted(() => {
  console.dir(CollapseItemRefs.value);
  // 深拷贝
  showData.value = initialData.value;
});
const data = ref({
  checked: "-1",
  loading: true,
  examTime: {
    _value: 0,
    _max: 1800,
  },
  examScore: {
    _value: 0,
    _max: 100,
  },
  themeVars: {
    circleTextColor: "#777777",
  },
  examList_is: [],
  examList_no: [],
});
const allSelect = ref(false);

//  上传文件后回显
const afterRead = (file) => {
  console.log(file);
  // Dialog.alert({
  //   title: "标题",
  //   message: file.content,
  // });
  // 账号 密码 目标分数 目标时间(秒) 课群ID 考试ID
  initialData.value = file.content.split("\n").map((item) => {
    const arr = item.split(" ");
    return {
      phone: arr[0],
      password: arr[1],
      targetScore: parseInt(arr[2]),
      targetTime: parseInt(arr[3]),
      groupId: arr[4],
      examId: arr[5],
      isSuccess: 0,
    };
  });
  // initialData.value = showData.value;
};

const isFailure = (isSuccess) => {
  if (isSuccess == 0) return "CollapseItem-default";
  return isSuccess == 1 ? "CollapseItem-true" : "CollapseItem-false";
};

// 监听Tab切换
watch(active, (val) => {
  CollapseIsShow.value = false;
  setTimeout(() => {
    transitionName.value = val == 1 ? "van-slide-right" : "van-slide-left";
    CollapseIsShow.value = true;
    console.log("a");
    showData.value =
      val == 0
        ? initialData.value
        : initialData.value.filter((item) => item.isSuccess == -1);
  }, 100);
});
watch(allSelect, (val) => {
  selectS.value = selectS.value.map(() => val);
  // 改变下方按钮的提示
});

const checkSelect = () => {
  console.log("选中检查");
};

const checkAll = () => {
  console.log("全部检查");
  showData.value = initialData.value.map(() => {
    return {
      phone: "666",
      isSuccess: 1,
    };
  });
  // initialData.value = showData.value;
};
// 监听initialData的变化且改变显示的数据
watch(initialData, (val) => {
  console.log("initialData");
  showData.value = val;
});
</script>

<style>
.van-card__price {
  position: absolute;
  bottom: 0;
}
.dot {
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 100%;
  background: #999999;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}
.van-collapse-item__content {
  background: #f7f8fa;
}
.CollapseItem-false {
  border-left: 7px solid #c01e0c;
}
.CollapseItem-true {
  border-left: 7px solid #19c42e;
}
.CollapseItem-default {
  border-left: 7px solid #999999;
}
/* 列表内容盒子 */
.list-content {
  font-size: 21px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 180px;
  margin-left: 8px;
}
/* 列表手机号内容 */
.list-content-phone {
  font-size: 32px;
  font-weight: bold;
  color: #000000b8;
  line-height: 32px;
}
/* 列表状态提示内容 */
.list-content-status {
  font-size: 14px;
  font-weight: bold;
  color: #00000078;
  padding-left: 3px;
}

.my-swipe .van-swipe-item {
  color: rgb(25, 137, 250);
  font-size: 12px;
  font-weight: bold;
  line-height: 42px;
  text-align: center;
  background-color: rgb(200 238 255);
}
.van-uploader__input-wrapper {
  width: 100%;
}
.Collapse_ {
  margin-bottom: 60px;
}
:root {
  --van-animation-duration-base: 0.1s;
}
</style>
